<template>
  <NuxtImg
    src="/img/world-map.svg"
    alt="world-map"
    class="world-map-style"
    loading="lazy"
    :class="{
      'hidden md:block': props.isTop == true,
      'md:hidden': props.isTop != true,
    }"
    width="1475"
    height="838"
  />
</template>

<script setup>
const props = defineProps({
  isTop: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped>
.world-map-style {
  @apply md:z-0 w-max md:absolute md:left-[0] md:top-0 md:w-full md:-mt-[5rem];
}
</style>
